import {makeStyles} from "@material-ui/core/styles";
import React from "react";
import {isEmpty} from "lodash";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Box from "@material-ui/core/Box";
import {Avatar} from "@material-ui/core";
import ReceiptIcon from "@material-ui/icons/Receipt";
import {DateRangeIcon} from "@material-ui/pickers/_shared/icons/DateRangeIcon";
import Typography from "@material-ui/core/Typography";
import {toDollars} from "../../utils";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import List from "@material-ui/core/List";
import ChargedItem from "./ChargedItem";
import PropTypes from "prop-types";
import {SummaryDetailData} from "./shared.propTypes";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    panelSummary: {
        width: '100%',
        flexGrow: 1,
        flexShrink: 1,
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    panelDetails: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    summaryTitle: {
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    summaryAmount: {
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    summaryAvatar: {
        marginRight: theme.spacing(1),
    },
    avatarColor: {
        backgroundColor: '#515151'
    },
    itemsList: {
        width: '100%'
    }
}));

const setDataCyText = (feeType) => {
    return feeType === 'initial' ? 'initial' : 'recurring'
}

function DetailsData ({type, info, data}) {
    const cls = useStyles();
    const label = type === 'initial' ? 'Initial Parking Fees' : 'Recurring Monthly Fees';
    const groups = data.groups && data.groups instanceof Array ? data.groups : [];
    const items = type === 'initial' && !isEmpty(groups) ? groups.reduce((list, group) => {
        const {label, types} = group;
        let _items = data.items.filter(item => types.includes(item.type) && item.total > 0);
        const taxes = {label: 'Taxes', price: _items.reduce((a, i) => a + i.taxes, 0), nested: true}
        const total = {label: 'Total', price: _items.reduce((a, i) => a + i.total, 0), nested: true};
        const title = {label: label.toString(), price: total.price, nested: false};
        _items = [title].concat(_items).concat([taxes]);
        return list.concat(_items.map((item, i, {length}) => {
            return {nested: i !== 0, divider: length > i + 1, ...item};
        }));
    }, []) : data.items.concat([
        {label: 'Taxes', price: data.taxes, nested: false, divider: false},
    ]).map((item, i, {length}) => ({divider: length > (i + 1), nested: false, ...item}));
    return <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <Box className={cls.panelSummary}>
                <Box className={cls.summaryTitle}>
                    <Avatar classes={{root: cls.summaryAvatar, colorDefault: cls.avatarColor}}>
                        {type === 'initial' ? <ReceiptIcon/> : <DateRangeIcon/>}
                    </Avatar>
                    <Box>
                        <Typography variant="body1" data-cy={`${setDataCyText(type)}-fee-text`}>{label}</Typography>
                        <Typography variant="caption" data-cy={`${setDataCyText(type)}-fee-subtext`}>{info}</Typography>
                    </Box>
                </Box>
                <Box className={cls.summaryAmount} data-cy={`${setDataCyText(type)}-value-text`}>{toDollars(data.total)}</Box>
            </Box>
        </AccordionSummary>
        <AccordionDetails>
            <List className={cls.itemsList} dense>{items.filter(({price}) => price > 0).map((item, i) => (
                <ChargedItem key={i} label={item.label} price={item.price} nested={item.nested} divider={item.divider}/>
            ))}</List>
        </AccordionDetails>
    </Accordion>
}
DetailsData.propTypes = {
    type: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    data: SummaryDetailData.isRequired
}
export default React.memo(DetailsData);
